/* eslint-disable import/prefer-default-export */
import { USA_AND_TERRITORIES } from '@airtm/utils/dist/constants';
import { PARTNER } from '@airtm/utils/dist/constants/userRoles';
import { WithUser_me } from 'graphqlDocuments/queries/__generated__/WithUser';

export const resolvers = {
  Auth__User: {
    canUseP2P: (root: WithUser_me): boolean => !USA_AND_TERRITORIES.includes(root?.country ?? ''),

    isPartner: (root: WithUser_me): boolean => !!root?.roles?.includes(PARTNER),
  },
};
